/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import config from '@/config'
import Deliverer from '@jojosz/config-deliverer'
import i18n from './i18n'

const { env } = config
let tempEnv = env
if (!['fat', 'dev', 'uat', 'pro'].includes(env)) {
  tempEnv = 'pro'
}
// 实例化配置平台工具包
const deliverer = new Deliverer({
  env: tempEnv, // 环境变量
  appKey: 'AA7SYAHPVWN', // 应用key
  appSecret: 'f5e043c61ee819e8' // 应用secret
})
Vue.config.productionTip = false
Vue.prototype.$deliverer = deliverer
new Vue({
  render: h => h(App)
}).$mount('#app')

// 国际化
i18n()

